const isProduction = process.env.NODE_ENV === 'production';
export const datalakeProxyUrl = isProduction ? 'https://zxe0rklmbg.execute-api.eu-west-1.amazonaws.com/prod/data' : 'https://6ivol66l37.execute-api.eu-west-1.amazonaws.com/dev/data';
